<template>
  <section class="container">
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div
          class="col-lg-7 col-md-6 col-sm-6 col-12 d-flex align-items-center"
        >
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view capi">Help: {{ slugName }}</h1>
        </div>
        <div class="col-lg-5 col-md-6 col-sm-6 col-12 alinmov3">
          <BoxSearch />
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <section>
        <div class="row">
          <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
            <div class="card">
              <div v-show="articles.docs.length === 0">
                <base-alert type="secondary" class="alert-box mx-3 ">
                  <h4><strong>Not Found!</strong></h4>
                  There are no results here. <br />
                  Try Again with other search terms
                  <img
                    src="~rhomtrip_assets/src/img/character/not-found.png"
                    alt="RhomTrip no fount"
                    class="character"
                  />
                </base-alert>
              </div>

              <div v-show="articles.docs.length > 0">
                <div class="mb-2 pt-0">
                  <base-pagination
                    :pageCount="articles.pages"
                    :total="articles.count"
                    :limit="limit"
                    v-model="currentPage"
                    @changePage="changePage"
                    @nextPage="nextPaginations"
                    @prevPage="previousPaginations"
                    :align="'center'"
                  ></base-pagination>
                </div>

                <div>
                  <div
                    class="col-xl-12"
                    v-for="(item, index) in documentsOptions"
                    :key="index"
                  >
                    <router-link
                      :to="gotToDocument(item)"
                      class="box-card-documents"
                    >
                      <div class="card-documents card-h card-lg-h">
                        <div class="row">
                          <div
                            class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12 align-self-center pr-0"
                          >
                            <div class="header-box">
                              <div class="carousel-box">
                                <div class="container-img">
                                  <div class="img-box">
                                    <img
                                      v-lazy="item.image"
                                      :alt="`${item.title}`"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-xl-9 col-lg-9 col-md-8 col-sm-8 col-12 align-self-center"
                          >
                            <div class="content-card">
                              <h4 class="card-title">
                                {{ item.title }}
                              </h4>

                              <div class="excerpt">
                                <p>
                                  {{ item.short_description }}
                                </p>
                              </div>

                              <div class="footer-product">
                                <div
                                  v-if="
                                    item.module &&
                                      ['GUIDE', 'SUPPORT'].indexOf(item.type) >
                                        -1
                                  "
                                >
                                  <router-link
                                    :to="`/help/${getSlugByValue(item.module)}`"
                                    class="type mr-2"
                                  >
                                    {{ getModuleName(item.module) }}
                                  </router-link>
                                  <router-link
                                    :to="`/help/${getSlugByValue(item.type)}`"
                                    class="type"
                                  >
                                    {{ getTypeName(item.type) }}
                                  </router-link>
                                </div>
                                <div v-else>
                                  <router-link
                                    :to="`/help/release`"
                                    class="type"
                                  >
                                    Release
                                  </router-link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>

                <div class="footer-section pb-3">
                  <base-pagination
                    :pageCount="articles.pages"
                    :total="articles.count"
                    :limit="limit"
                    v-model="currentPage"
                    @changePage="changePage"
                    @nextPage="nextPaginations"
                    @prevPage="previousPaginations"
                    :align="'center'"
                  ></base-pagination>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12 ">
            <div class="card pb-3">
              <h2 class="max-title text-left mb-3">Related</h2>

              <card-articles
                v-if="value"
                size="md"
                :excerpt="true"
                :searchCriteria="{
                  filtering: getFiltering(value, simpleText),
                  sorting: {
                    sort: 'MOST_RECENT',
                    order: 'DESCENDING'
                  },
                  pagination: {
                    limit: 5,
                    page: 1
                  }
                }"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import apps from "../../Commons/Utility/Apps";
import WSelect from "@/components/Select";
import Swal from "sweetalert2";
import CardArticles from "./Components/CardArticles";
import BoxSearch from "./Components/BoxSearch";
import endpoint from "../../Commons/Services";
import { goBack } from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "HelpResults",
  data() {
    return {
      currentPage: 1,
      limit: 10,
      modules: apps.modules,
      documents: [],
      slug: "",
      slugName: "",
      searchCriteriaRelated: null,
      slug: this.$route.params.moduleSlug,
      value: "",
      simpleText: this.$route.query.text ? this.$route.query.text : "",
      query: `?app=SUPPLIERS`,
      articles: {
        count: 0,
        page: 0,
        pages: 0,
        docs: []
      },
      metaTagParams: {
        titlePage: "Help | RhomTrip Suppliers"
      }
    };
  },
  watch: {
    "$route.params": {
      handler: async function(current, old) {
        this.slug = current.moduleSlug;
        this.initData(this.slug);
      },
      deep: true
    }
  },
  async mounted() {
    this.initData(this.slug);
  },

  methods: {
    async initData(slug) {
      this.value = this.getValueBySlug(slug);
      this.slugName = this.getNameByValue(this.value, this.simpleText);
      this.query = this.getQuery(this.query, this.value, this.simpleText);
      await this.get(true, this.limit, this.currentPage, this.query);
      console.log(this.value, this.query);
      var bread = [
        {
          text: "Help",
          to: "/help"
        },
        {
          text: this.slugName,
          active: true
        }
      ];

      this.setItemsBread(bread);
    },
    getQuery(query, value, simpleText) {
      if (["RELEASE", "GUIDE", "SUPPORT"].indexOf(value) > -1) {
        return this.addElementInQuery(query, "type", value);
      } else if (value === "searchResults") {
        return this.addElementInQuery(query, "simpleText", simpleText);
      } else {
        return this.addElementInQuery(query, "module", value);
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    gotToDocument(document) {
      if (document.type === "RELEASE") {
        return `/help/release/${document.slug}`;
      } else {
        return `/help/${this.getSlugByValue(document.module)}/${document.slug}`;
      }
    },
    getSlugByValue(value) {
      if (value === "ACCOUNT") {
        return "account";
      } else if (value === "DRIVERS") {
        return "drivers";
      } else if (value === "AREAS") {
        return "areas";
      } else if (value === "CUSTOMERS") {
        return "customers";
      } else if (value === "DESTINATIONS") {
        return "destinations";
      } else if (value === "GLOBAL") {
        return "global";
      } else if (value === "LOGS") {
        return "logs";
      } else if (value === "PROFILE") {
        return "profile";
      } else if (value === "RATES") {
        return "rates";
      } else if (value === "RESERVATIONS") {
        return "reservations";
      } else if (value === "USERS") {
        return "user";
      } else if (value === "VEHICLES") {
        return "vehicles";
      } else if (value === "SCHEDULE") {
        return "schecule";
      } else if (value === "RELEASE") {
        return "release";
      } else if (value === "GUIDE") {
        return "guide";
      } else if (value === "SUPPORT") {
        return "support";
      }
    },
    getValueBySlug(value) {
      if (value === "account") {
        return "ACCOUNT";
      } else if (value === "drivers") {
        return "DRIVERS";
      } else if (value === "areas") {
        return "AREAS";
      } else if (value === "customers") {
        return "CUSTOMERS";
      } else if (value === "destinations") {
        return "DESTINATIONS";
      } else if (value === "schedule") {
        return "SCHEDULE";
      } else if (value === "global") {
        return "GLOBAL";
      } else if (value === "users") {
        return "USERS";
      } else if (value === "logs") {
        return "LOGS";
      } else if (value === "profile") {
        return "PROFILE";
      } else if (value === "rates") {
        return "RATES";
      } else if (value === "reservations") {
        return "RESERVATIONS";
      } else if (value === "vehicles") {
        return "VEHICLES";
      } else if (value === "release") {
        return "RELEASE";
      } else if (value === "guide") {
        return "GUIDE";
      } else if (value === "support") {
        return "SUPPORT";
      } else {
        return "searchResults";
      }
    },
    getFiltering(slug, simpleText = "") {
      if (["RELEASE", "GUIDE", "SUPPORT"].indexOf(slug) > -1) {
        return {
          app: "SUPPLIERS",
          type: slug,
          status: "PUBLISHED"
        };
      } else if (slug === "searchResults") {
        return {
          app: "SUPPLIERS",
          simpleText: simpleText,
          status: "PUBLISHED"
        };
      } else {
        return {
          app: "SUPPLIERS",
          module: slug,
          status: "PUBLISHED"
        };
      }
    },
    getNameByValue(value, simpleText = "") {
      if (["RELEASE", "GUIDE", "SUPPORT"].indexOf(value) > -1) {
        return this.getTypeName(value);
      } else if (value === "searchResults") {
        return simpleText;
      } else {
        return this.getModuleName(value);
      }
    },
    getTypeName(type) {
      if (type === "RELEASE") {
        return "Release";
      } else if (type === "GUIDE") {
        return "Guide";
      } else if (type === "SUPPORT") {
        return "Support";
      }
    },
    getModuleName(module) {
      let item = this.modules.find(i => i.value === module);
      if (item) {
        return item.name;
      } else {
        return "";
      }
    },
    async get(loader, limit, page, query) {
      this.setLoad(loader);
      this.articles = await this.getArticles(query, limit, page);
      this.setLoad(false);
    },
    async getArticles(query, limit = 10, page = 1) {
      try {
        let { data } = await endpoint.documents.services.getArticles(
          query,
          limit,
          page
        );

        if (data.status) {
          return data.data;
        } else {
          return {
            count: 0,
            page: 0,
            pages: 0,
            docs: []
          };
        }
      } catch (error) {
        return {
          count: 0,
          page: 0,
          pages: 0,
          docs: []
        };
      }
    },
    async changeLimit(limit) {
      await this.get(true, limit, this.currentPage, this.query);
    },
    async previousPaginations(page) {
      await this.get(true, this.limit, page, this.query);
    },
    async nextPaginations(page) {
      await this.get(true, this.limit, page, this.query);
    },
    async changePage(page) {
      await this.get(true, this.limit, page, this.query);
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    ...mapMutations(["setItemsBread", "setLoad", "setMetaTags"])
  },
  computed: {
    documentsOptions: function() {
      return this.articles.docs.map(document => {
        return {
          _id: document._id,
          title: document.title,
          type: document.type,
          app: document.app,
          module: document.module,
          image:
            document.images.length > 0
              ? document.images[0]
              : "https://upcdn.io/FW25b8h/raw/documents/covers/rhomtrip-img-doc.png",
          short_description: document.short_description,
          slug: document.slug
        };
      });
    },
    ...mapGetters(["sesion", "sigout", "metaTags"])
  },
  filters: {},
  components: {
    WSelect: WSelect,
    Swal,
    CardArticles: CardArticles,
    BoxSearch: BoxSearch
  },
  async beforeMount() {
    this.setMetaTags(this.metaTagParams);
  },
  metaInfo() {
    return this.metaTags;
  }
};
</script>
